import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useStore } from '../store/useStore';
import { db } from '../db/db';

// --- STYLES ---
const STYLES = `
  :root {
    --bg: #e8ecec;
    --surface: #ffffff;
    --surface2: #f1f5f9;
    --surface3: #e2e8f0;
    --border: #aebec8;
    --border2: #aebec8;
    --accent: #1e8585;
    --accent2: #15666b;
    --green: #15803d;
    --red: #dc2626;
    --amber: #d97706;
    --text: #000000;
    --text2: #333333;
    --text3: #64748b;
    --font-ui: ui-sans-serif, system-ui, -apple-system, sans-serif;
    --font-mono: ui-monospace, SFMono-Regular, monospace;
    --font-display: ui-sans-serif, system-ui, sans-serif;
    --radius: 0px;
    --shadow: none;

    --accent-rgb: 30, 133, 133;
    --green-rgb: 21, 128, 61;
    --red-rgb: 220, 38, 38;
    --amber-rgb: 217, 119, 6;
  }
  
  .erp-page {
    padding: 8px;
    gap: 8px;
    height: 100%;
    box-sizing: border-box;
    background: var(--bg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .import-wrapper {
    background: var(--bg); color: var(--text);
    font-family: var(--font-ui); font-size: 12px;
    height: 100%; width: 100%; overflow-x: hidden;
    display: flex; flex-direction: column; flex: 1;
  }
  *, *::before, *::after { box-sizing: border-box; }

  #topbar-actions .btn-ghost { color: var(--text2); border-color: rgba(0,0,0,0.3); }
  #topbar-actions .btn-ghost:hover { background: rgba(0,0,0,0.05); color: var(--text); }
  #topbar {
    display: flex; justify-content: space-between; align-items: center;
    background: #1e8585; color: #ffffff; padding: 2px 8px; border-bottom: 1px solid var(--border);
    min-height: 28px;
  }
  .logo { display: none; }
  .topbar-divider { display: none; }
  .topbar-title { font-size: 12px; font-weight: bold; color: #ffffff; text-transform: none; }
  .topbar-actions { margin-left: auto; display: flex; align-items: center; gap: 6px; }

  .btn { display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 2px 8px; border-radius: var(--radius); border: 1px solid var(--border); font-family: var(--font-ui); font-size: 11px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
  .btn-ghost { background: var(--surface); color: var(--text); }
  .btn-ghost:hover { background: var(--surface2); color: var(--text); }
  .btn-primary { background: var(--accent); color: #fff; border: 1px solid var(--accent); }
  .btn-primary:hover { background: #1b7070; }
  .btn-success { background: var(--green); color: #fff; border: 1px solid var(--green); }
  .btn-success:hover { background: #166534; }
  .btn-danger { background: var(--red); color: #fff; border: 1px solid var(--red); }
  .btn:disabled { opacity: 0.4; cursor: not-allowed; }

  .bank-import-wrap #app-layout { 
    display: grid; 
    grid-template-columns: 1fr 280px; 
    gap: 8px; 
    max-width: none; 
    width: 100%;
    flex: 1;
    margin: 0; 
    align-items: start;
  }
  .bank-import-wrap #main-area { 
    background: var(--surface); 
    border: 1px solid var(--border); 
    border-radius: var(--radius); 
    padding: 12px; 
    box-shadow: var(--shadow);
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 400px;
  }
  .bank-import-wrap #sidebar { 
    background: var(--surface); 
    border: 1px solid var(--border); 
    border-radius: var(--radius); 
    padding: 12px; 
    box-shadow: var(--shadow);
    display: flex; 
    flex-direction: column;
    position: sticky;
    top: 8px;
  }

  .card { display: flex; flex-direction: column; width: 100%; flex: 1; }
  .card-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px solid var(--border); }
  .card-title { font-size: 14px; font-weight: 700; color: var(--text); }
  .card-subtitle { font-size: 11px; color: var(--text2); margin-top: 0px; font-weight: normal; }

  .bank-select {
    background: var(--surface); color: var(--text); border: 1px solid var(--border);
    padding: 6px 12px; border-radius: var(--radius); font-family: var(--font-ui); font-size: 12px;
    width: 100%; outline: none; cursor: pointer; transition: border-color 0.2s;
  }
  .bank-select:focus { border-color: var(--accent); }
  .bank-select:disabled { opacity: 0.5; cursor: not-allowed; }
  .bank-select-mini {
    background: transparent; color: #ffffff; border: none; font-family: var(--font-ui);
    font-size: 12px; font-weight: 600; outline: none; cursor: pointer; padding: 0;
  }
  .bank-select-mini option { background: var(--surface); color: var(--text); }

  #upload-zone { 
    position: relative;
    border: 2px dashed var(--border); 
    padding: 24px; 
    text-align: center; 
    cursor: pointer; 
    background: var(--surface2); 
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    justify-content: center; 
    min-height: 180px; 
    margin-top: 12px;
  }
  #upload-zone:hover:not(.disabled), #upload-zone.drag-over:not(.disabled) { border-color: var(--accent); background: rgba(var(--accent-rgb),0.04); }
  #upload-zone.disabled { opacity: 0.4; cursor: not-allowed; }
  #upload-zone.disabled input { display: none; }
  #upload-zone input { position: absolute; inset: 0; opacity: 0; cursor: pointer; }
  .upload-icon { font-size: 48px; margin-bottom: 16px; }
  .upload-title { font-family: var(--font-display); font-size: 20px; font-weight: 600; margin-bottom: 8px; }
  .upload-sub { color: var(--text2); font-size: 13px; }
  .format-badge { background: var(--surface3); border: 1px solid var(--border2); border-radius: 5px; padding: 3px 10px; font-family: var(--font-mono); font-size: 12px; color: var(--text2); }
  .upload-formats { display: flex; gap: 8px; justify-content: center; margin-top: 16px; }

  .progress-track { background: var(--surface3); border-radius: 100px; height: 6px; overflow: hidden; }
  .progress-fill { height: 100%; background: linear-gradient(90deg, var(--accent), var(--accent2)); border-radius: 100px; transition: width 0.3s; }
  .progress-steps { display: flex; gap: 12px; margin-top: 16px; flex-wrap: wrap; }
  .progress-step { display: flex; align-items: center; gap: 6px; font-size: 12px; color: var(--text3); transition: color 0.2s; }
  .progress-step.active { color: var(--accent); }
  .progress-step.done { color: var(--green); }
  .step-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--border2); transition: background 0.2s; flex-shrink: 0; }
  .progress-step.active .step-dot { background: var(--accent); }
  .progress-step.done .step-dot { background: var(--green); }

  .filter-tabs { display: flex; gap: 2px; background: var(--surface2); border: 1px solid var(--border); border-radius: 8px; padding: 3px; }
  .filter-tab { padding: 5px 14px; border-radius: 6px; font-size: 12px; font-weight: 500; cursor: pointer; transition: all 0.15s; color: var(--text2); border: none; background: transparent; font-family: var(--font-ui); }
  .filter-tab.active { background: var(--surface3); color: var(--text); }

  .grid-wrapper { flex: 1; overflow: auto; border-radius: 8px; border: 1px solid var(--border); min-height: 400px; margin-top: 16px; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  thead th { background: var(--surface2); padding: 10px 14px; text-align: left; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--text2); border-bottom: 1px solid var(--border); white-space: nowrap; position: sticky; top: 0; z-index: 2; }
  tbody tr { transition: background 0.1s; border-bottom: 1px solid var(--border); }
  tbody tr:hover { background: var(--surface2); }
  tbody tr.row-error { background: rgba(var(--red-rgb),0.06); }
  tbody tr.row-duplicate { background: rgba(var(--amber-rgb),0.05); }
  tbody tr.row-imported { opacity: 0.5; }
  tbody td { padding: 9px 14px; vertical-align: middle; }

  .badge { display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; border-radius: 4px; font-family: var(--font-mono); font-size: 11px; font-weight: 500; }
  .badge-debit { background: rgba(var(--red-rgb),0.15); color: var(--red); }
  .badge-credit { background: rgba(var(--green-rgb),0.15); color: var(--green); }
  .badge-warn { background: rgba(var(--amber-rgb),0.15); color: var(--amber); }
  .badge-error { background: rgba(var(--red-rgb),0.2); color: var(--red); }
  .badge-grey { background: var(--surface3); color: var(--text2); }
  .badge-needs-ledger { background: rgba(var(--amber-rgb),0.2); color: var(--amber); }

  .amount-cell { font-family: var(--font-mono); font-size: 13px; font-weight: 500; }
  .debit-amount { color: var(--red); }
  .credit-amount { color: var(--green); }
  .date-cell { font-family: var(--font-mono); font-size: 12px; white-space: nowrap; }
  .narration-cell { font-size: 12px; color: var(--text2); max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .error-tooltip { font-size: 11px; color: var(--red); margin-top: 2px; }

  /* Searchable Dropdown */
  .ledger-dropdown-wrap { position: relative; min-width: 200px; }
  .ledger-input { background: var(--surface2); border: 1px solid var(--border); color: var(--text); font-family: var(--font-mono); font-size: 12px; width: 100%; padding: 5px 9px; border-radius: 5px; outline: none; transition: border-color 0.15s; }
  .ledger-input:focus { border-color: var(--accent); background: var(--surface3); }
  .ledger-input.missing { border-color: rgba(var(--amber-rgb),0.7); background: rgba(var(--amber-rgb),0.05); }
  .ledger-input.has-value { border-color: rgba(var(--green-rgb),0.5); }
  .ledger-dropdown-menu { position: absolute; top: calc(100% + 4px); left: 0; right: 0; background: var(--surface2); border: 1px solid var(--border2); border-radius: 7px; z-index: 50; max-height: 200px; overflow-y: auto; box-shadow: var(--shadow); }
  .ledger-dropdown-item { padding: 7px 12px; font-size: 12px; cursor: pointer; color: var(--text); transition: background 0.1s; }
  .ledger-dropdown-item:hover, .ledger-dropdown-item.highlighted { background: var(--surface3); color: var(--accent); }
  .ledger-dropdown-item.suggested { color: var(--amber); }
  .ledger-dropdown-item.suggested::after { content: ' ★'; font-size: 10px; opacity: 0.7; }
  .ledger-dropdown-empty { padding: 8px 12px; font-size: 12px; color: var(--text3); font-style: italic; }
  .ledger-sub { font-size: 10px; margin-top: 2px; }
  .ledger-sub.missing { color: var(--amber); }
  .ledger-sub.ready { color: var(--green); }

  .stat-row { display: flex; justify-content: space-between; margin-bottom: 12px; align-items: center; }
  .stat-row:last-child { border-bottom: none; }
  .stat-label { font-size: 13px; color: var(--text2); }
  .stat-value { font-size: 14px; font-weight: 600; color: var(--text); font-family: var(--font-mono); text-align: right; }
  .stat-value.green { color: var(--green); }
  .stat-value.red { color: var(--red); }
  .stat-value.amber { color: var(--amber); }

  .sidebar-section { margin-bottom: 0px; display: flex; flex-direction: column; }
  .sidebar-heading { font-family: var(--font-display); font-size: 14px; font-weight: 600; color: var(--text); margin-bottom: 16px; letter-spacing: 0.02em; text-transform: uppercase; }
  .sidebar-divider { height: 1px; background: var(--border); margin: 24px 0; }

  .modal-overlay { position: fixed; inset: 0; z-index: 200; background: rgba(0,0,0,0.7); display: flex; align-items: center; justify-content: center; }
  .modal { background: var(--surface); border: 1px solid var(--border2); border-radius: 12px; padding: 28px; width: 480px; box-shadow: var(--shadow); }
  .modal-title { font-family: var(--font-display); font-size: 18px; font-weight: 600; margin-bottom: 14px; }
  .modal-body { font-size: 13px; color: var(--text2); line-height: 1.6; margin-bottom: 20px; }
  .modal-actions { display: flex; justify-content: flex-end; gap: 10px; }

  #toast-container { position: fixed; bottom: 24px; right: 24px; z-index: 300; display: flex; flex-direction: column; gap: 8px; }
  .toast { background: var(--surface2); border: 1px solid var(--border2); border-radius: 8px; padding: 12px 16px; font-size: 13px; color: var(--text); display: flex; align-items: center; gap: 10px; min-width: 280px; animation: slideIn 0.2s ease; box-shadow: var(--shadow); }
  .toast.success { border-left: 3px solid var(--green); }
  .toast.error { border-left: 3px solid var(--red); }
  .toast.warning { border-left: 3px solid var(--amber); }
  .toast.info { border-left: 3px solid var(--accent); }
  @keyframes slideIn { from { transform: translateX(40px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
  .fade-in { animation: fadeIn 0.25s ease; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }

  .journal-entry { background: var(--surface2); border: 1px solid var(--border); border-radius: 8px; padding: 14px 16px; margin-bottom: 10px; font-family: var(--font-mono); font-size: 12px; }
  .je-dr { color: var(--red); padding-left: 0; }
  .je-cr { color: var(--green); padding-left: 20px; }
  .je-meta { font-size: 10px; color: var(--text3); margin-top: 6px; text-transform: uppercase; letter-spacing: 0.05em; }

  .empty-state { text-align: center; padding: 48px 24px; }
  .empty-icon { font-size: 40px; margin-bottom: 12px; opacity: 0.5; }
  .empty-text { color: var(--text2); font-size: 13px; }

  .grid-toolbar { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; flex-wrap: wrap; }
  .bulk-bar { display: flex; align-items: center; gap: 6px; background: var(--surface2); padding: 4px 10px; border-radius: 8px; border: 1px solid var(--border); }

  input[type="checkbox"] { accent-color: var(--accent); }
  ::-webkit-scrollbar { width: 6px; height: 6px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: var(--border2); border-radius: 3px; }

  .loading-indicator { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; color: var(--text2); }
  .spinner { width: 12px; height: 12px; border: 2px solid var(--border2); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.7s linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* Virtual table — fixed-height scroll container with positional rendering */
  .vtable-container { overflow-y: auto; border-radius: var(--radius); border: 1px solid var(--border); position: relative; }
  .vtable-header { display: grid; background: var(--surface2); border-bottom: 1px solid var(--border); position: sticky; top: 0; z-index: 2; }
  .vtable-header-cell { padding: 10px 14px; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--text2); white-space: nowrap; }
  .vtable-scroll { position: relative; }
  .vtable-row { display: grid; position: absolute; width: 100%; height: 40px; /* must match ROW_HEIGHT constant */ overflow: hidden; border-bottom: 1px solid var(--border); transition: background 0.1s; align-items: center; }
  .vtable-row:hover { background: var(--surface2); }
  .vtable-row.row-error { background: rgba(var(--red-rgb),0.06); }
  .vtable-row.row-duplicate { background: rgba(var(--amber-rgb),0.05); }
  .vtable-row.row-imported { opacity: 0.5; }
  .vtable-cell { padding: 9px 14px; font-size: 13px; overflow: hidden; min-width: 0; }
  .vtable-perf-note { font-size: 11px; color: var(--text3); padding: 6px 14px; background: var(--surface2); border-top: 1px solid var(--border); display: flex; align-items: center; gap: 6px; }
`;

// --- CONSTANTS ---










// --- UTILS ---
import { sleep, sanitizeCell, formatDate, fmtNum, parseAmountStrict, parseCSV } from '../utils/importUtils';
import { PIPELINE_STEPS, CHUNK_SIZE, suggestLedger, fetchLedgers, fetchBankAccounts, fetchLedgerMemory, saveLedgerMemory, apiCreateVouchers, DATE_FORMATS } from '../services/importBankService';

// ---------------------------------------------------------------------------
// VIRTUAL TABLE & DROPDOWN (Imported from components)
// ---------------------------------------------------------------------------
import { VirtualTable } from '../components/import/VirtualTable';
import { LedgerDropdown } from '../components/import/LedgerDropdown';

const ROW_HEIGHT = 56;        // px — must stay in sync with vtable-cell padding
const OVERSCAN = 5;           // rows rendered outside the visible window
const VIRTUALIZE_THRESHOLD = 120; // rows — below this, use plain table

// Column widths in px / fr — must sum to 100% of the container
const COL_TEMPLATE = '36px 48px 100px 1fr 110px 110px 90px 130px 220px 100px';

// ---------------------------------------------------------------------------
// TABLE ROW CELLS
// Single source of truth for row rendering, shared by both the plain <table>
// path (rendered inside <tr> as <td>s via asTd=true) and the virtual table
// path (rendered inside an absolutely-positioned <div> as plain <div>s).
// ---------------------------------------------------------------------------
function TableRowCells({
  r, selectedRows, toggleRowSelect,
  availableLedgers, ledgerMemory, ledgersLoading, updateLedger,
  modal, setModal, postVouchersToBackend, selectedBank, showToast,
  asTd = false,
}) {
  const Cell = asTd ? 'td' : 'div';
  const cellClass = asTd ? '' : 'vtable-cell';

  return (
    <>
      <Cell className={cellClass} style={{ paddingLeft: 14 }}>
        <input type="checkbox" checked={selectedRows.has(r.idx)} onChange={e => toggleRowSelect(r.idx, e.target.checked)} />
      </Cell>
      <Cell className={cellClass} style={{ color: 'var(--text3)', fontFamily: 'var(--font-mono)', fontSize: 11 }}>
        {r.idx + 1}
      </Cell>
      <Cell className={`${cellClass} date-cell`}>
        {r.parsedDate ? formatDate(r.parsedDate) : <span style={{ color: 'var(--red)' }}>{r.rawDate || '—'}</span>}
      </Cell>
      <Cell className={cellClass}>
        <div className="narration-cell" title={r.narration}>{r.narration.substring(0, 45)}</div>
        {r.errors.map((e, i) => <div key={i} className="error-tooltip">⚠ {e.msg}</div>)}
      </Cell>
      <Cell className={cellClass}>
        {r.debit > 0 ? <span className="amount-cell debit-amount">₹ {fmtNum(r.debit)}</span> : '—'}
      </Cell>
      <Cell className={cellClass}>
        {r.credit > 0 ? <span className="amount-cell credit-amount">₹ {fmtNum(r.credit)}</span> : '—'}
      </Cell>
      <Cell className={cellClass}>
        {r.debit > 0
          ? <span className="badge badge-debit">PAYMENT</span>
          : <span className="badge badge-credit">RECEIPT</span>}
        {!r.isValid && <span className="badge badge-error" style={{ marginLeft: 4 }}>ERR</span>}
        {r.isDuplicate && <span className="badge badge-warn" style={{ marginLeft: 4 }}>DUP</span>}
        {r.status === 'posted' && <span className="badge badge-grey" style={{ marginLeft: 4 }}>POSTED</span>}
      </Cell>
      <Cell className={cellClass} style={{ fontSize: 11, color: 'var(--text2)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.party}>
        {r.party || <span style={{ color: 'var(--amber)' }}>Missing</span>}
      </Cell>
      <Cell className={cellClass}>
        {r.isValid && r.status !== 'posted' && !r.isDuplicate
          ? <LedgerDropdown
              value={r.ledger}
              onChange={val => updateLedger(r.idx, val)}
              ledgers={availableLedgers}
              memoryLedger={r.party ? ledgerMemory[r.party.toUpperCase()] : null}
              suggested={suggestLedger(r.party, r.narration, r.side)}
              disabled={ledgersLoading}
            />
          : r.status === 'posted'
            ? <span style={{ fontSize: 12, color: 'var(--text2)', fontFamily: 'var(--font-mono)' }}>{r.ledger}</span>
            : r.isDuplicate
              ? <span style={{ fontSize: 11, color: 'var(--amber)' }}>Excluded (duplicate)</span>
              : <span style={{ fontSize: 11, color: 'var(--text3)' }}>—</span>
        }
      </Cell>
      <Cell className={cellClass}>
        {r.isValid && !r.isDuplicate && r.status !== 'posted'
          ? <button
              className="btn btn-success"
              style={{ padding: '4px 10px', fontSize: 11 }}
              disabled={!r.ledger || !availableLedgers.includes(r.ledger) || !!modal}
              onClick={() => {
                if (modal) return;
                if (!r.ledger) { showToast('Assign a ledger before posting', 'error'); return; }
                if (!availableLedgers.includes(r.ledger)) { showToast(`Ledger "${r.ledger}" is not in the approved list. Re-assign before posting.`, 'error'); return; }
                setModal({
                  title: 'Create Voucher',
                  body: `Post <strong>₹${fmtNum(r.debit || r.credit)}</strong> ${r.debit ? 'payment to' : 'receipt from'} <strong>${r.party}</strong> under <strong>${selectedBank}</strong>?`,
                  onConfirm: () => postVouchersToBackend([r]),
                });
              }}
            >Create</button>
          : r.status === 'posted'
            ? <span style={{ color: 'var(--green)', fontSize: 12 }}>✓ Posted</span>
            : r.isDuplicate
              ? <span style={{ color: 'var(--amber)', fontSize: 12 }}>Skipped</span>
              : <span style={{ color: 'var(--red)', fontSize: 12 }}>Invalid</span>
        }
      </Cell>
    </>
  );
}

// --- MAIN APP ---
export default function App() {
  const [view, setView] = useState('upload');
  const [fileInfo, setFileInfo] = useState({ name: '', type: '', size: 0 });
  const [rawRows, setRawRows] = useState(null);
  const [parsedRows, setParsedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [selectedBank, setSelectedBank] = useState('');
  const [bulkLedger, setBulkLedger] = useState('');
  const [filter, setFilter] = useState('all');
  const [progress, setProgress] = useState({ step: 0, total: PIPELINE_STEPS.length });
  const [toasts, setToasts] = useState([]);
  const [modal, setModal] = useState(null);
  const [showJournalPanel, setShowJournalPanel] = useState(false);

  // Ledger system
  const activeCompany = useStore((state) => state.activeCompany);
  const [availableLedgers, setAvailableLedgers] = useState<string[]>([]);
  const [ledgersLoading, setLedgersLoading] = useState(true);
  const [ledgerMemory, setLedgerMemory] = useState({});
  const [availableBanks, setAvailableBanks] = useState<string[]>([]);
  const [banksLoading, setBanksLoading] = useState(true);

  // Load ledgers + memory + bank accounts on mount or company change
  useEffect(() => {
    let cancelled = false;

    const loadFromDb = async () => {
      if (!activeCompany) return;
      setLedgersLoading(true);
      setBanksLoading(true);

      const [ls, banks, mem] = await Promise.all([
        fetchLedgers(),
        fetchBankAccounts(),
        fetchLedgerMemory()
      ]);
      
      if (cancelled) return;
      
      setAvailableLedgers(ls);
      setAvailableBanks(banks);
      setLedgerMemory(mem);
      setLedgersLoading(false);
      setBanksLoading(false);
    };

    loadFromDb();

    // Listen for db-updated (fired by db manipulations)
    const onDbUpdated = () => {
      if (!cancelled) loadFromDb();
    };
    window.addEventListener('db-updated', onDbUpdated);

    return () => {
      cancelled = true;
      window.removeEventListener('db-updated', onDbUpdated);
    };
  }, [activeCompany]);

  // Load XLSX
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).XLSX) {
      const script = document.createElement('script');
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const showToast = useCallback((msg, type = 'success') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, msg, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
  }, []);

  const resetAll = useCallback(() => {
    setView('upload');
    setFileInfo({ name: '', type: '', size: 0 });
    setRawRows(null);
    setParsedRows([]);
    setSelectedRows(new Set());
    setSelectedBank('');
    setFilter('all');
    setShowJournalPanel(false);
  }, []);

  // --- BANK HANDLER ---
  const handleBankChange = (e) => {
    const newBank = e.target.value;
    if (!newBank) return;
    if ((view === 'grid' || view === 'progress') && rawRows) {
      setModal({
        title: 'Reprocess Bank Statement?',
        body: `Changing the target bank to <strong>${newBank}</strong> requires reprocessing the current statement. All manual ledger assignments will be lost. Proceed?`,
        onConfirm: () => {
          setModal(null);
          setSelectedBank(newBank);
          // Use setTimeout so state update flushes before pipeline runs
          setTimeout(() => runParsingPipeline(rawRows), 0);
        }
      });
    } else {
      setSelectedBank(newBank);
    }
  };

  // --- PARSING ---
  const handleFileSelect = (file) => {
    if (!file) return;
    if (!selectedBank) {
      showToast('Action Blocked: Please select a Target Bank Account first.', 'error');
      return;
    }
    const ext = file.name.split('.').pop().toLowerCase();
    setFileInfo({ name: file.name, type: ext.toUpperCase(), size: file.size });
    if (!['csv', 'xlsx', 'xls'].includes(ext)) {
      showToast('Unsupported file format. Please use CSV or XLSX.', 'error'); return;
    }
    if (ext === 'csv') {
      const reader = new FileReader();
      reader.onload = (ev) => dispatchRawRows(parseCSV(ev.target.result));
      reader.readAsText(file, 'UTF-8');
    } else {
      if (!(window as any).XLSX) { showToast('Excel parser not loaded yet', 'error'); return; }
      const reader = new FileReader();
      reader.onload = (ev) => {
        try {
          const data = new Uint8Array(ev.target.result as ArrayBuffer);
          const wb = (window as any).XLSX.read(data, { type: 'array', cellDates: true });
          const ws = wb.Sheets[wb.SheetNames[0]];
          const rows = (window as any).XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', raw: false });
          dispatchRawRows(rows.map(r => r.map(c => String(c === null || c === undefined ? '' : c))));
        } catch (e) { showToast('Failed to parse Excel', 'error'); }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const dispatchRawRows = (rows) => {
    if (!rows || rows.length < 2) { showToast('File appears to be empty', 'error'); return; }
    const expectedHeaders = ['date', 'party', 'debit', 'credit', 'narration'];
    const headerRow = rows[0].map(c => sanitizeCell(c).toLowerCase());
    const isValidStructure = expectedHeaders.every((val, index) => headerRow[index] === val);
    if (!isValidStructure) {
      showToast('Invalid file structure. Columns must exactly match: Date | Party | Debit | Credit | Narration', 'error');
      return;
    }
    setRawRows(rows);
    runParsingPipeline(rows);
  };

  const runParsingPipeline = async (allRows) => {
    setShowJournalPanel(false);
    setParsedRows([]);
    setSelectedRows(new Set());
    setView('progress');
    setProgress({ step: 0, total: PIPELINE_STEPS.length });
    await sleep(60);

    const memorySnapshot = { ...ledgerMemory };
    const dataRows = allRows.slice(1).filter(r => r.some(c => c && String(c).trim()));

    // ── Seed hashRegistry from existing DB vouchers (catches re-imports) ──────
    const hashRegistry = new Set<string>();
    try {
      if (activeCompany?.id) {
        const existingVouchers = await db.vouchers
          .where('companyId').equals(activeCompany.id)
          .filter(v => !v.deleted && (v.type === 'Payment' || v.type === 'Receipt'))
          .toArray();
        const existingVoucherIds = existingVouchers.map(v => v.id!).filter(Boolean);
        const existingEntries = existingVoucherIds.length > 0
          ? await db.voucherEntries.where('voucherId').anyOf(existingVoucherIds).toArray()
          : [];
        const ledgerIds = [...new Set(existingEntries.map(e => e.ledgerId))];
        const relevantLedgers = ledgerIds.length > 0
          ? await db.ledgers.where('id').anyOf(ledgerIds).toArray()
          : [];
        const ledgerMap = new Map(relevantLedgers.map(l => [l.id, l]));

        for (const v of existingVouchers) {
          const vEntries = existingEntries.filter(e => e.voucherId === v.id);
          const amount = vEntries.reduce((sum, e) => e.type === 'Dr' ? sum + e.amount : sum, 0);
          // Find party ledger (non-bank side)
          const partyEntry = vEntries.find(e => {
            const l = ledgerMap.get(e.ledgerId);
            return l && !l.name?.toLowerCase().includes('bank') && l.name?.toLowerCase() !== 'cash';
          }) || vEntries[0];
          const partyLedger = partyEntry ? ledgerMap.get(partyEntry.ledgerId) : null;
          const partyKey = (partyLedger?.name || '').toUpperCase().replace(/\s+/g, '').substring(0, 40);
          const narKey = (v.narration || '').toLowerCase().replace(/\s+/g, '').substring(0, 40);
          const amtKey = Number(amount.toFixed(2)) * 100;
          const dk = v.date;
          hashRegistry.add(`${dk}|${amtKey}|${partyKey}|${narKey}`);
        }
      }
    } catch (e) {
      console.warn('[BankImport] Could not pre-seed duplicate registry from DB:', e);
    }
    // ──────────────────────────────────────────────────────────────────────────
    const results = [];   // ← FIX: was missing, causing "results is not defined" crash
    let processed = 0;

    for (let chunkStart = 0; chunkStart < dataRows.length; chunkStart += CHUNK_SIZE) {
      const chunk = dataRows.slice(chunkStart, chunkStart + CHUNK_SIZE);
      for (let i = 0; i < chunk.length; i++) {
        const raw = chunk[i];
        const rawDate = sanitizeCell(raw[0]);
        const rawParty = sanitizeCell(raw[1]);
        const rawDebit = sanitizeCell(raw[2]);
        const rawCredit = sanitizeCell(raw[3]);
        const rawNarration = sanitizeCell(raw[4]);

        if (!rawDate && !rawParty && !rawDebit && !rawCredit && !rawNarration) continue;

        const errors = [];
        let parsedDate = null;
        if (!rawDate) {
          errors.push({ msg: 'Missing Date' });
        } else {
          let s = rawDate.trim().replace(/\s/g, '').replace(/\./g, '/');
          let dateValid = false;
          for (const { re, parse } of DATE_FORMATS) {
            const m = s.match(re);
            if (m) {
              let d; try { d = parse(m); } catch (e) { continue; }
              if (d && !isNaN(d.getTime())) { parsedDate = d; dateValid = true; break; }
            }
          }
          if (!dateValid) errors.push({ msg: `Invalid Date Format: "${rawDate}"` });
        }

        const party = rawParty.trim();
        if (!party) errors.push({ msg: 'Missing Party' });

        const drStr = rawDebit.replace(/[₹$€£¥₦₩]/g, '').trim();
        const crStr = rawCredit.replace(/[₹$€£¥₦₩]/g, '').trim();
        const drVal = parseAmountStrict(drStr);
        const crVal = parseAmountStrict(crStr);
        const drOk = !isNaN(drVal);
        const crOk = !isNaN(crVal);
        let debit = 0, credit = 0;

        if (drOk && crOk && drVal !== 0 && crVal !== 0) {
          errors.push({ msg: 'Both Debit and Credit filled' });
        } else if ((!drOk || drVal === 0) && (!crOk || crVal === 0)) {
          errors.push({ msg: 'Zero or missing amount' });
        } else {
          if (drOk && drVal !== 0) { if (drVal < 0) credit = Math.abs(drVal); else debit = drVal; }
          if (crOk && crVal !== 0) { if (crVal < 0) debit = Math.abs(crVal); else credit = crVal; }
        }

        let isDuplicate = false;
        if (debit || credit) {
          const dk = parsedDate ? parsedDate.toISOString().slice(0, 10) : rawDate.toLowerCase().replace(/\s+/g, '');
          const narKey = rawNarration.toLowerCase().replace(/\s+/g, '').substring(0, 40);
          const partyKey = party.toUpperCase().replace(/\s+/g, '').substring(0, 40);
          const eh = `${dk}|${Number((Math.abs(debit || credit)).toFixed(2)) * 100}|${partyKey}|${narKey}`;
          if (hashRegistry.has(eh)) isDuplicate = true;
          else hashRegistry.add(eh);
        }

        // Auto-apply ledger from memory or suggestion (with debit/credit context)
        const txSide = debit > 0 ? 'debit' : 'credit';
        const memLedger = memorySnapshot[party.toUpperCase()] || null;
        const sugLedger = suggestLedger(party, rawNarration, txSide);
        let autoLedger;
        if (memLedger) autoLedger = memLedger;
        else if (sugLedger) autoLedger = sugLedger;
        else autoLedger = '';

        results.push({
          idx: chunkStart + i, rawDate, parsedDate,
          narration: rawNarration.trim(), party,
          debit, credit,
          side: txSide,
          errors, isDuplicate,
          isValid: errors.length === 0,
          ledger: autoLedger,
          ledgerSource: memLedger ? 'memory' : (sugLedger ? 'suggestion' : 'manual'),
          status: 'pending',
        });
      }
      processed += chunk.length;
      setProgress({ step: 1 + (processed / dataRows.length) * 2, total: PIPELINE_STEPS.length });
      await sleep(10);
    }

    setProgress({ step: PIPELINE_STEPS.length, total: PIPELINE_STEPS.length });
    await sleep(200);
    setParsedRows(results);
    setView('grid');
    const autoAssigned = results.filter(r => r.ledger && r.isValid).length;
    const unresolved = results.filter(r => r.isValid && !r.isDuplicate && !r.ledger).length;
    // Auto-switch to the most actionable filter
    if (unresolved > 0) {
      setFilter('needs-ledger');
      showToast(`Processed ${results.length} rows — ${unresolved} need ledger assignment.`, 'warning');
    } else {
      setFilter('ready');
      showToast(`Processed ${results.length} rows. ${autoAssigned} ledgers auto-assigned. All ready.`, 'success');
    }
  };

  // --- ACTIONS ---
  const updateLedger = useCallback((idx, val) => {
    setParsedRows(prev => {
      const row = prev.find(r => r.idx === idx);
      if (row && row.party && val) {
        if (row.party.length > 2) { saveLedgerMemory(row.party, val); }
        setLedgerMemory(mem => ({ ...mem, [row.party.toUpperCase()]: val }));
      }
      return prev.map(r => r.idx === idx ? { ...r, ledger: val, ledgerSource: 'manual' } : r);
    });
  }, []);

  // --- COMPUTED (placed before action handlers so filteredRows is available to them) ---
  const stats = useMemo(() => {
    const valid = parsedRows.filter(r => r.isValid && !r.isDuplicate);
    const needsLedger = parsedRows.filter(r => r.isValid && !r.isDuplicate && !r.ledger && r.status !== 'posted');
    const ready = parsedRows.filter(r => r.isValid && !r.isDuplicate && !!r.ledger && r.status !== 'posted');
    const errors = parsedRows.filter(r => !r.isValid);
    const dupes = parsedRows.filter(r => r.isDuplicate);
    const posted = parsedRows.filter(r => r.status === 'posted');
    const totalDebit = valid.reduce((s, r) => s + r.debit, 0);
    const totalCredit = valid.reduce((s, r) => s + r.credit, 0);
    const net = totalCredit - totalDebit;
    const dates = valid.map(r => r.parsedDate).filter(d => d);
    const dateRange = dates.length ? `${formatDate(new Date(Math.min(...dates)))} – ${formatDate(new Date(Math.max(...dates)))}` : '—';
    return { total: parsedRows.length, valid: valid.length, needsLedger: needsLedger.length, ready: ready.length, errors: errors.length, dupes: dupes.length, posted: posted.length, totalDebit, totalCredit, net, dateRange };
  }, [parsedRows]);

  const filteredRows = useMemo(() => {
    return parsedRows.filter(r => {
      if (filter === 'all') return true;
      if (filter === 'ready') return r.isValid && !r.isDuplicate && !!r.ledger && r.status !== 'posted';
      if (filter === 'needs-ledger') return r.isValid && !r.isDuplicate && !r.ledger && r.status !== 'posted';
      if (filter === 'error') return !r.isValid;
      if (filter === 'duplicate') return r.isDuplicate;
      if (filter === 'posted') return r.status === 'posted';
      return true;
    });
  }, [parsedRows, filter]);

  const toggleRowSelect = (idx, checked) => {
    setSelectedRows(prev => {
      const next = new Set(prev);
      if (checked) next.add(idx); else next.delete(idx);
      return next;
    });
  };

  const toggleSelectAll = (checked) => {
    const visibleIdxs = filteredRows.map(r => r.idx);
    setSelectedRows(prev => {
      const next = new Set(prev);
      visibleIdxs.forEach(i => checked ? next.add(i) : next.delete(i));
      return next;
    });
  };

  // Apply bulk ledger to selected
  const applyBulkLedger = () => {
    if (!bulkLedger) return;
    const affected = parsedRows.filter(r => selectedRows.has(r.idx));
    if (!affected.length) return;
    setModal({
      title: 'Confirm Bulk Ledger Assignment',
      body: `Assign ledger <strong>${bulkLedger}</strong> to <strong>${affected.length} selected row(s)</strong>? This will overwrite any existing ledger on those rows.`,
      onConfirm: () => {
        setParsedRows(prev => prev.map(r => selectedRows.has(r.idx) ? { ...r, ledger: bulkLedger, ledgerSource: 'manual' } : r));
        const memUpdates = {};
        affected.forEach(r => { if (r.party && r.party.length > 2) { saveLedgerMemory(r.party, bulkLedger); memUpdates[r.party.toUpperCase()] = bulkLedger; } });
        if (Object.keys(memUpdates).length) setLedgerMemory(mem => ({ ...mem, ...memUpdates }));
        showToast(`Applied "${bulkLedger}" to ${affected.length} row(s)`);
        setBulkLedger('');
        setSelectedRows(new Set());
        setModal(null);
      },
    });
  };

  // Apply bulk ledger to all visible rows
  const applyBulkLedgerToVisible = () => {
    if (!bulkLedger) return;
    const visible = filteredRows.map(r => r.idx);
    const affected = parsedRows.filter(r => visible.includes(r.idx));
    if (!affected.length) return;
    setModal({
      title: 'Confirm Bulk Ledger Assignment',
      body: `Assign ledger <strong>${bulkLedger}</strong> to all <strong>${affected.length} visible row(s)</strong>? This will overwrite any existing ledger on those rows.`,
      onConfirm: () => {
        setParsedRows(prev => prev.map(r => visible.includes(r.idx) ? { ...r, ledger: bulkLedger, ledgerSource: 'manual' } : r));
        const memUpdates = {};
        affected.forEach(r => { if (r.party && r.party.length > 2) { saveLedgerMemory(r.party, bulkLedger); memUpdates[r.party.toUpperCase()] = bulkLedger; } });
        if (Object.keys(memUpdates).length) setLedgerMemory(mem => ({ ...mem, ...memUpdates }));
        showToast(`Applied "${bulkLedger}" to all ${visible.length} visible row(s)`);
        setBulkLedger('');
        setModal(null);
      },
    });
  };

  const postVouchersToBackend = async (rowsToPost) => {
    // Gate 1: ledger present
    const missing = rowsToPost.filter(r => !r.ledger || !r.ledger.trim());
    if (missing.length > 0) {
      showToast(`Action Blocked: ${missing.length} row(s) missing Ledger Assignment`, 'error');
      setModal(null); return;
    }
    // Gate 2: ledger must exist in the approved ledger list (prevents stale or injected values)
    const ledgerSet = new Set(availableLedgers);
    const invalidLedger = rowsToPost.find(r => !ledgerSet.has(r.ledger));
    if (invalidLedger) {
      showToast(`Action Blocked: Ledger "${invalidLedger.ledger}" is not in the approved ledger list. Re-assign before posting.`, 'error');
      setModal(null); return;
    }
    // Gate 3: bank must be selected
    if (!selectedBank) {
      showToast('Action Blocked: No bank selected.', 'error');
      setModal(null); return;
    }
    try {
      const payloads = rowsToPost.map(r => ({
        rowIdx: r.idx, matchedLedger: r.ledger, debit: r.debit, credit: r.credit,
        bankAccount: { name: selectedBank }, party: r.party,
        date: formatDate(r.parsedDate), narration: r.narration,
      }));
      const results = await apiCreateVouchers(payloads);
      const successes = new Set(results.filter(res => res.success).map(res => res.rowIdx));
      const failures = results.filter(res => !res.success);
      if (successes.size > 0) {
        setParsedRows(prev => prev.map(r => {
          if (!successes.has(r.idx)) return r;
          const res = results.find(x => x.rowIdx === r.idx);
          return { ...r, status: 'posted', refId: res?.refId };
        }));
        const memUpdates = {};
        rowsToPost.filter(r => successes.has(r.idx) && r.party && r.party.length > 2 && r.ledger).forEach(r => {
          saveLedgerMemory(r.party, r.ledger);
          memUpdates[r.party.toUpperCase()] = r.ledger;
        });
        if (Object.keys(memUpdates).length) setLedgerMemory(mem => ({ ...mem, ...memUpdates }));
        setSelectedRows(new Set());
        showToast(`✓ ${successes.size} voucher(s) saved to books`, 'success');
        if (failures.length > 0) {
          setTimeout(() => showToast(`⚠ ${failures.length} failed: ${failures[0].error || 'Unknown error'}`, 'error'), 400);
        }
      } else {
        const firstErr = failures[0]?.error || 'Voucher creation failed';
        showToast(`Failed: ${firstErr}`, 'error');
      }
    } catch (e) {
      showToast('API Error', 'error');
    }
    setModal(null);
  };

  const handleApproveSelected = () => {
    const ledgerSet = new Set(availableLedgers);
    const toApprove = parsedRows.filter(r => selectedRows.has(r.idx) && r.isValid && r.status !== 'posted' && !r.isDuplicate);
    if (!toApprove.length) { showToast('No valid, non-duplicate rows selected', 'warning'); return; }
    const missingLedger = toApprove.filter(r => !r.ledger);
    if (missingLedger.length) {
      showToast(`${missingLedger.length} selected row(s) still missing ledger`, 'error'); return;
    }
    const invalidLedger = toApprove.find(r => !ledgerSet.has(r.ledger));
    if (invalidLedger) {
      showToast(`Action Blocked: Ledger "${invalidLedger.ledger}" is not in the approved ledger list. Re-assign before posting.`, 'error'); return;
    }
    if (!selectedBank) {
      showToast('Action Blocked: No bank selected.', 'error'); return;
    }
    setModal({
      title: 'Post Selected Vouchers',
      body: `Create <strong>${toApprove.length} voucher(s)</strong> under <strong>${selectedBank}</strong>. This cannot be undone.`,
      onConfirm: () => postVouchersToBackend(toApprove),
    });
  };

  const handleApproveAll = () => {
    const ledgerSet = new Set(availableLedgers);
    const toApprove = parsedRows.filter(r => r.isValid && !r.isDuplicate && r.status !== 'posted' && r.ledger && ledgerSet.has(r.ledger));
    if (!toApprove.length) { showToast('No ready rows to post', 'warning'); return; }
    if (parsedRows.some(r => !r.isValid)) {
      setModal({ title: 'Approval Blocked', body: `<strong>Errors exist.</strong> Please resolve or remove invalid rows first.`, onConfirm: null });
      return;
    }
    setModal({
      title: 'Bulk Voucher Creation',
      body: `Create <strong>${toApprove.length} accounting voucher(s)</strong> under <strong>${selectedBank}</strong> in the database?`,
      onConfirm: () => postVouchersToBackend(toApprove),
    });
  };

  const generateJournalEntry = (row) => {
    const date = formatDate(row.parsedDate) || row.rawDate;
    const narration = row.narration.substring(0, 60);
    const ledger = row.ledger || '--- UNASSIGNED ---';
    const entryType = row.debit > 0 ? 'Payment Voucher' : 'Receipt Voucher';
    return {
      type: row.debit > 0 ? 'debit' : 'credit', entryType, date, narration, amount: row.debit || row.credit,
      entries: row.debit > 0
        ? [{ side: 'Dr', account: ledger, amount: row.debit }, { side: 'Cr', account: selectedBank, amount: row.debit }]
        : [{ side: 'Dr', account: selectedBank, amount: row.credit }, { side: 'Cr', account: ledger, amount: row.credit }]
    };
  };

  const FILTER_TABS = [
    { key: 'all', label: 'All', count: stats.total },
    { key: 'ready', label: 'Ready', count: stats.ready },
    { key: 'needs-ledger', label: 'Needs Ledger', count: stats.needsLedger },
    { key: 'error', label: 'Error', count: stats.errors },
    { key: 'duplicate', label: 'Duplicate', count: stats.dupes },
    { key: 'posted', label: 'Posted', count: stats.posted },
  ];

  return (
    <div className="import-wrapper bank-import-wrap">
        <style dangerouslySetInnerHTML={{ __html: STYLES }} />

      <div id="topbar">
        <div className="logo">Aarthika<span>Pro</span></div>
        <div className="topbar-divider" />
        <div className="topbar-title">Bank Statement Import</div>
        <div className="topbar-actions">
          {view !== 'upload' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--surface2)', padding: '6px 12px', borderRadius: 8, border: '1px solid var(--border2)' }}>
              <span style={{ fontSize: 12, color: 'var(--text2)' }}>Bank:</span>
              <select className="bank-select-mini" value={selectedBank} onChange={handleBankChange}>
                {availableBanks.map(b => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>
          )}
          {view !== 'upload' && <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: '#cffafe' }}>{fileInfo.name}</span>}
          {view !== 'upload' && <button className="btn btn-ghost" onClick={resetAll}>↺ Start Over</button>}
          {view === 'grid' && stats.errors > 0 && (
            <button className="btn btn-ghost" style={{ borderColor: 'rgba(var(--red-rgb),0.4)', color: 'var(--red)' }}
              onClick={() => setFilter('error')} title="Errors are hidden from posting. Click to review.">
              ⚠ {stats.errors} Error{stats.errors !== 1 ? 's' : ''}
            </button>
          )}
          {view === 'grid' && selectedRows.size > 0 && (
            <button className="btn btn-success" onClick={handleApproveSelected} disabled={!!modal}>
              ✓ Post Selected ({selectedRows.size})
            </button>
          )}
          {view === 'grid' && <button className="btn btn-primary" onClick={handleApproveAll} disabled={!!modal}>⚡ Post All Ready</button>}
        </div>
      </div>

      <div className="erp-page">
      <div id="app-layout">
        <div id="main-area">

          {/* UPLOAD VIEW */}
          {view === 'upload' && (
            <div className="card fade-in">
              <div className="card-header">
                <div><div className="card-title">Import Bank Statement</div><div className="card-subtitle">Receipt & Payment vouchers only</div></div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-ghost" style={{ gap: 5, fontSize: 11 }} onClick={() => {
                    const rows = [
                      ['Date','Party','Debit','Credit','Narration'],
                      ['01/04/2025','Ramesh Traders Pvt Ltd','15000','','Payment for goods - April'],
                      ['03/04/2025','Suresh Suppliers Ltd','','8500','Receipt against invoice'],
                      ['05/04/2025','Kavita Enterprises','22000','','Vendor payment batch'],
                      ['07/04/2025','Mumbai Steel Co','','31200','Receipt - order #1042'],
                      ['10/04/2025','Delhi Auto Parts LLP','9750','','Rent payment April'],
                      ['12/04/2025','Gupta & Sons','','4100','Commission received'],
                      ['15/04/2025','Ravi Distributors','18600','','Salary disbursement'],
                      ['18/04/2025','National Traders','','12000','Customer advance receipt'],
                    ];
                    const csv = rows.map(r => r.map(c => `"${c}"`).join(',')).join('\n');
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a'); a.href = url; a.download = 'bank_import_sample.csv'; a.click();
                    URL.revokeObjectURL(url);
                  }}>⬇ Sample CSV</button>
                  <button className="btn btn-ghost" style={{ gap: 5, fontSize: 11 }} onClick={() => {
                    const rows = [
                      ['Date','Party','Debit','Credit','Narration'],
                      ['01/04/2025','Ramesh Traders Pvt Ltd','15000','','Payment for goods - April'],
                      ['03/04/2025','Suresh Suppliers Ltd','','8500','Receipt against invoice'],
                      ['05/04/2025','Kavita Enterprises','22000','','Vendor payment batch'],
                      ['07/04/2025','Mumbai Steel Co','','31200','Receipt - order #1042'],
                      ['10/04/2025','Delhi Auto Parts LLP','9750','','Rent payment April'],
                      ['12/04/2025','Gupta & Sons','','4100','Commission received'],
                      ['15/04/2025','Ravi Distributors','18600','','Salary disbursement'],
                      ['18/04/2025','National Traders','','12000','Customer advance receipt'],
                    ];
                    if (!(window as any).XLSX) { showToast('Excel library not loaded yet, try again in a moment', 'warning'); return; }
                    const ws = (window as any).XLSX.utils.aoa_to_sheet(rows);
                    ws['!cols'] = [{ wch: 12 }, { wch: 28 }, { wch: 12 }, { wch: 12 }, { wch: 30 }];
                    const wb = (window as any).XLSX.utils.book_new();
                    (window as any).XLSX.utils.book_append_sheet(wb, ws, 'Bank Import');
                    (window as any).XLSX.writeFile(wb, 'bank_import_sample.xlsx');
                  }}>⬇ Sample XLSX</button>
                </div>
              </div>

              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', marginBottom: 8, fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>
                  Select Target Bank Account <span style={{ color: 'var(--red)' }}>*</span>
                </label>
                <select className="bank-select" value={selectedBank} onChange={e => setSelectedBank(e.target.value)}
                  disabled={banksLoading}>
                  <option value="" disabled>
                    {banksLoading ? 'Loading bank accounts…' : availableBanks.length === 0 ? '— No company open —' : '-- Choose a Bank Account --'}
                  </option>
                  {availableBanks.map(b => <option key={b} value={b}>{b}</option>)}
                </select>
                {!banksLoading && availableBanks.length === 0 && (
                  <div style={{ fontSize: 11, color: 'var(--red)', marginTop: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>⚠ No company is open. Please open a company first — bank accounts will load automatically.</span>
                    <button className="btn btn-ghost" style={{ fontSize: 11, padding: '2px 8px' }} onClick={() => {
                      setBanksLoading(true);
                      Promise.all([fetchLedgers(), fetchBankAccounts()]).then(([ls, banks]) => {
                        setAvailableLedgers(ls);
                        setAvailableBanks(banks);
                        setBanksLoading(false);
                      });
                    }}>↺ Refresh</button>
                  </div>
                )}
                {!selectedBank && availableBanks.length > 0 && (
                  <div style={{ fontSize: 11, color: 'var(--amber)', marginTop: 6 }}>⚠ File upload is blocked until a bank is selected</div>
                )}
              </div>

              <div style={{ marginBottom: 20, border: '1px solid rgba(var(--accent-rgb),0.35)', borderRadius: 10, background: 'rgba(var(--accent-rgb),0.05)', overflow: 'hidden' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 18px', background: 'rgba(var(--accent-rgb),0.10)', borderBottom: '1px solid rgba(var(--accent-rgb),0.2)' }}>
                  <span style={{ fontSize: 15 }}>📋</span>
                  <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--accent)', letterSpacing: '0.02em' }}>Strict Format Required</span>
                  <span style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--text2)', background: 'rgba(var(--accent-rgb),0.15)', padding: '2px 8px', borderRadius: 4, fontFamily: 'var(--font-mono)' }}>Exact Header Match</span>
                </div>
                <div style={{ padding: '16px 18px' }}>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: 12, background: 'var(--surface2)', border: '1px solid var(--border2)', borderRadius: 6, padding: '10px 14px', color: 'var(--text)', marginBottom: 14 }}>
                    <span style={{ color: 'var(--accent)' }}>Date</span><span style={{ color: 'var(--text3)' }}> | </span>
                    <span style={{ color: 'var(--amber)' }}>Party</span><span style={{ color: 'var(--text3)' }}> | </span>
                    <span style={{ color: 'var(--red)' }}>Debit</span><span style={{ color: 'var(--text3)' }}> | </span>
                    <span style={{ color: 'var(--green)' }}>Credit</span><span style={{ color: 'var(--text3)' }}> | </span>
                    <span>Narration</span>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    {[
                      ['✓', 'Debit > 0 → Payment Voucher', 'var(--green)'],
                      ['✓', 'Credit > 0 → Receipt Voucher', 'var(--green)'],
                      ['✗', 'Missing date or party → rejected', 'var(--red)'],
                      ['✗', 'Both debit & credit filled → rejected', 'var(--red)'],
                      ['★', 'Ledger auto-suggested from party name', 'var(--amber)'],
                      ['★', 'Mapping memory fills previous ledgers', 'var(--amber)'],
                    ].map((item, i) => (
                      <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: 'var(--text2)' }}>
                        <span style={{ color: item[2], flexShrink: 0, marginTop: 1 }}>{item[0]}</span><span>{item[1]}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div
                id="upload-zone"
                className={(!selectedBank || availableBanks.length === 0) ? 'disabled' : ''}
                onDragOver={e => { e.preventDefault(); if (!selectedBank) e.dataTransfer.dropEffect = 'none'; }}
                onDrop={(e) => {
                  e.preventDefault();
                  if (availableBanks.length === 0) { showToast('Open a company first to load bank accounts.', 'error'); return; }
                  if (!selectedBank) { showToast('Action blocked: Select a Bank Account first.', 'error'); return; }
                  handleFileSelect(e.dataTransfer.files[0]);
                }}
                onClick={() => {
                  if (availableBanks.length === 0) showToast('Open a company first to load bank accounts.', 'error');
                  else if (!selectedBank) showToast('Action blocked: Select a Bank Account first.', 'warning');
                }}
              >
                <input type="file" accept=".csv,.xlsx,.xls" disabled={!selectedBank || availableBanks.length === 0} onChange={e => { if (selectedBank) handleFileSelect(e.target.files[0]); }} />
                <div className="upload-icon" style={{ opacity: selectedBank ? 1 : 0.4 }}>📂</div>
                <div className="upload-title">
                  {availableBanks.length === 0 ? 'Open a company to enable upload' : selectedBank ? 'Drop or click to upload' : 'Select a bank to enable upload'}
                </div>
                <div className="upload-sub">
                  {availableBanks.length === 0 ? 'No company is open — bank accounts cannot be loaded' : selectedBank ? `Uploading to: ${selectedBank}` : 'Bank selection is required before upload'}
                </div>
                <div className="upload-formats"><span className="format-badge">.CSV</span><span className="format-badge">.XLSX</span><span className="format-badge">.XLS</span></div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 20 }}>
                <div style={{ fontSize: 11, color: 'var(--text3)', fontFamily: 'var(--font-mono)', background: 'var(--surface2)', padding: '4px 10px', borderRadius: 6, border: '1px solid var(--border2)' }}>
                  Select Bank → Upload → Review → Post → Voucher Created
                </div>
              </div>
            </div>
          )}

          {/* PROGRESS VIEW */}
          {view === 'progress' && (
            <div className="card fade-in">
              <div className="card-header"><div className="card-title">🔄 Processing Statement for {selectedBank}</div></div>
              <div className="progress-track"><div className="progress-fill" style={{ width: `${(progress.step / progress.total) * 100}%` }}></div></div>
              <div className="progress-steps">
                {PIPELINE_STEPS.map((step, i) => (
                  <div key={i} className={`progress-step ${i < Math.floor(progress.step) ? 'done' : i === Math.floor(progress.step) ? 'active' : ''}`}>
                    <div className="step-dot" />{step}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* GRID VIEW */}
          {view === 'grid' && (
            <>
              <div className="card fade-in">
                <div className="card-header">
                  <div>
                    <div className="card-title">Transactions — {selectedBank}</div>
                    <div className="card-subtitle">
                      Ready: {stats.ready} / {stats.total} · {stats.needsLedger > 0 && <span style={{ color: 'var(--amber)' }}>{stats.needsLedger} need ledger · </span>}{stats.errors} errors · {stats.posted} posted
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--surface2)', padding: '6px 12px', borderRadius: 8, border: '1px solid var(--border2)' }}>
                      <span style={{ fontSize: 12, color: 'var(--text2)' }}>Bank:</span>
                      <select className="bank-select-mini" value={selectedBank} onChange={handleBankChange}>
                        {availableBanks.map(b => <option key={b} value={b}>{b}</option>)}
                      </select>
                    </div>
                    <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text2)' }}>{fileInfo.name}</span>
                    <button className="btn btn-ghost" onClick={resetAll}>↺ Start Over</button>
                    {stats.errors > 0 && (
                      <button className="btn btn-ghost" style={{ borderColor: 'rgba(var(--red-rgb),0.4)', color: 'var(--red)' }}
                        onClick={() => setFilter('error')} title="Errors are hidden from posting. Click to review.">
                        ⚠ {stats.errors} Error{stats.errors !== 1 ? 's' : ''}
                      </button>
                    )}
                    {selectedRows.size > 0 && (
                      <button className="btn btn-success" onClick={handleApproveSelected} disabled={!!modal}>
                        ✓ Post Selected ({selectedRows.size})
                      </button>
                    )}
                    <button className="btn btn-primary" onClick={handleApproveAll} disabled={!!modal}>⚡ Post All Ready</button>
                  </div>
                </div>

                {/* Toolbar */}
                <div className="grid-toolbar">
                  <div className="filter-tabs">
                    {FILTER_TABS.map(f => (
                      <button key={f.key} className={`filter-tab ${filter === f.key ? 'active' : ''}`} onClick={() => setFilter(f.key)}>
                        {f.label}{f.count > 0 && <span style={{ marginLeft: 4, opacity: 0.6, fontFamily: 'var(--font-mono)', fontSize: 10 }}>{f.count}</span>}
                      </button>
                    ))}
                  </div>

                  {/* Bulk ledger bar — shows when rows selected OR always visible for visible-apply */}
                  <div className="bulk-bar">
                    <span style={{ fontSize: 11, color: 'var(--text2)', whiteSpace: 'nowrap' }}>
                      {ledgersLoading ? <span className="loading-indicator"><span className="spinner" />Loading ledgers…</span> : 'Bulk:'}
                    </span>
                    <select
                      className="ledger-input"
                      style={{ minWidth: 170, padding: '3px 8px', fontSize: 12 }}
                      value={bulkLedger}
                      disabled={ledgersLoading}
                      onChange={e => setBulkLedger(e.target.value)}
                    >
                      <option value="">-- Select Ledger --</option>
                      {availableLedgers.map(l => <option key={l} value={l}>{l}</option>)}
                    </select>
                    {selectedRows.size > 0 && (
                      <button className="btn btn-primary" style={{ padding: '3px 10px', fontSize: 11 }} onClick={applyBulkLedger} disabled={!bulkLedger}>
                        Apply to {selectedRows.size} selected
                      </button>
                    )}
                    <button className="btn btn-ghost" style={{ padding: '3px 10px', fontSize: 11 }} onClick={applyBulkLedgerToVisible} disabled={!bulkLedger}>
                      Apply to {filteredRows.length} visible
                    </button>
                  </div>

                  <button className="btn btn-ghost" style={{ marginLeft: 'auto', fontSize: 12 }} onClick={() => setShowJournalPanel(!showJournalPanel)}>
                    📒 {showJournalPanel ? 'Hide' : 'Preview'} Journals
                  </button>
                </div>

                {/* Table — virtualized above VIRTUALIZE_THRESHOLD rows */}
                {filteredRows.length === 0 ? (
                  <div className="grid-wrapper">
                    <div className="empty-state"><div className="empty-icon">🔍</div><div className="empty-text">No rows match this filter</div></div>
                  </div>
                ) : filteredRows.length >= VIRTUALIZE_THRESHOLD ? (
                  /* ---- VIRTUAL TABLE (high-volume path) ---- */
                  <VirtualTable
                    rows={filteredRows}
                    containerHeight={560}
                    headers={['', '#', 'Date', 'Narration / Errors', 'Debit ₹', 'Credit ₹', 'Type', 'Party', 'Ledger', 'Action']}
                    renderRow={(r: any) => <TableRowCells r={r} selectedRows={selectedRows} toggleRowSelect={toggleRowSelect} availableLedgers={availableLedgers} ledgerMemory={ledgerMemory} ledgersLoading={ledgersLoading} updateLedger={updateLedger} modal={modal} setModal={setModal} postVouchersToBackend={postVouchersToBackend} selectedBank={selectedBank} showToast={showToast} />}
                  />
                ) : (
                  /* ---- PLAIN TABLE (low-volume path) ---- */
                  <div className="grid-wrapper">
                    <table>
                      <thead>
                        <tr>
                          <th><input type="checkbox" onChange={e => toggleSelectAll(e.target.checked)} /></th>
                          <th>#</th><th>Date</th><th>Narration / Errors</th>
                          <th>Debit ₹</th><th>Credit ₹</th><th>Type</th><th>Party</th><th>Ledger</th><th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredRows.map((r) => (
                          <tr key={r.idx} className={r.status === 'posted' ? 'row-imported' : !r.isValid ? 'row-error' : r.isDuplicate ? 'row-duplicate' : ''}>
                            <TableRowCells r={r} selectedRows={selectedRows} toggleRowSelect={toggleRowSelect} availableLedgers={availableLedgers} ledgerMemory={ledgerMemory} ledgersLoading={ledgersLoading} updateLedger={updateLedger} modal={modal} setModal={setModal} postVouchersToBackend={postVouchersToBackend} selectedBank={selectedBank} showToast={showToast} asTd />
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* Journal Preview Panel */}
              {showJournalPanel && (
                <div className="card fade-in">
                  <div className="card-header">
                    <div className="card-title">📒 Journal Entry Preview</div>
                    <button className="btn btn-ghost" onClick={() => setShowJournalPanel(false)}>✕ Close</button>
                  </div>
                  {parsedRows.filter(r => r.isValid && !r.isDuplicate && r.status !== 'posted').slice(0, 20).map((r, i) => {
                    const je = generateJournalEntry(r);
                    return (
                      <div className="journal-entry" key={i}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                          <span style={{ fontSize: 12, color: 'var(--text)' }}>{je.narration || r.party}</span>
                          <span style={{ fontSize: 11, color: 'var(--text2)' }}>{je.date}</span>
                        </div>
                        {je.entries.map((e, ei) => (
                          <div key={ei} style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0' }}>
                            <span className={e.side === 'Dr' ? 'je-dr' : 'je-cr'} style={{ paddingLeft: e.side === 'Cr' ? 20 : 0 }}>{e.side}  {e.account}</span>
                            <span className={e.side === 'Dr' ? 'je-dr' : 'je-cr'}>₹ {fmtNum(e.amount)}</span>
                          </div>
                        ))}
                        <div className="je-meta">{je.entryType}</div>
                      </div>
                    );
                  })}
                  {parsedRows.filter(r => r.isValid && !r.isDuplicate && r.status !== 'posted').length === 0 && (
                    <div className="empty-state"><div className="empty-icon">📭</div><div className="empty-text">No valid transactions ready to preview</div></div>
                  )}
                </div>
              )}
            </>
          )}

        </div>

        {/* SIDEBAR */}
        <div id="sidebar">
          {view === 'upload' ? (
            <div style={{ textAlign: 'center', color: 'var(--text3)', marginTop: '50%', transform: 'translateY(-50%)', padding: 20 }}>
              <div style={{ fontSize: 42, marginBottom: 16, opacity: 0.5 }}>📁</div>
              <div style={{ fontSize: 13, lineHeight: 1.6 }}>No file uploaded.<br />Select a Bank Account and upload to proceed.</div>
            </div>
          ) : (
            <>
              <div className="sidebar-section">
                <div className="sidebar-heading">Processing Summary</div>
                <div className="stat-row"><span className="stat-label">Total Rows</span><span className="stat-value">{stats.total}</span></div>
                <div className="stat-row"><span className="stat-label">Ready to Post</span><span className="stat-value green">{stats.ready}</span></div>
                <div className="stat-row"><span className="stat-label">Needs Ledger</span><span className="stat-value amber">{stats.needsLedger}</span></div>
                <div className="stat-row"><span className="stat-label">Errors</span><span className="stat-value red">{stats.errors}</span></div>
                <div className="stat-row"><span className="stat-label">Duplicates</span><span className="stat-value amber">{stats.dupes}</span></div>
                <div className="stat-row"><span className="stat-label">Posted</span><span className="stat-value green">{stats.posted}</span></div>
              </div>
              <div className="sidebar-divider" />
              <div className="sidebar-section">
                <div className="sidebar-heading">Financials</div>
                <div className="stat-row"><span className="stat-label">Total Debit</span><span className="stat-value red">₹ {fmtNum(stats.totalDebit)}</span></div>
                <div className="stat-row"><span className="stat-label">Total Credit</span><span className="stat-value green">₹ {fmtNum(stats.totalCredit)}</span></div>
                <div className="stat-row"><span className="stat-label">Net Flow</span><span className={`stat-value ${stats.net >= 0 ? 'green' : 'red'}`}>{stats.net >= 0 ? '+' : ''}₹ {fmtNum(Math.abs(stats.net))}</span></div>
              </div>
              <div className="sidebar-divider" />
              <div className="sidebar-section">
                <div className="sidebar-heading">File Info</div>
                <div className="stat-row"><span className="stat-label">Target Bank</span><span className="stat-value" style={{ color: 'var(--accent)', fontSize: 11, textAlign: 'right', maxWidth: 140, wordBreak: 'break-word' }}>{selectedBank}</span></div>
                <div className="stat-row"><span className="stat-label">File</span><span className="stat-value" style={{ fontSize: 11, textAlign: 'right', wordBreak: 'break-all', maxWidth: 140 }}>{fileInfo.name || '—'}</span></div>
                <div className="stat-row"><span className="stat-label">Date Range</span><span className="stat-value" style={{ fontSize: 11 }}>{stats.dateRange}</span></div>
              </div>
              {stats.needsLedger > 0 && (
                <>
                  <div className="sidebar-divider" />
                  <div style={{ background: 'rgba(var(--amber-rgb),0.08)', border: '1px solid rgba(var(--amber-rgb),0.25)', borderRadius: 8, padding: '12px 14px' }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--amber)', marginBottom: 6 }}>⚠ Action Required</div>
                    <div style={{ fontSize: 11, color: 'var(--text2)', lineHeight: 1.5 }}>
                      {stats.needsLedger} row(s) are missing a ledger assignment. Posting is blocked until all ledgers are assigned.
                    </div>
                    <button className="btn btn-ghost" style={{ marginTop: 10, width: '100%', fontSize: 11, padding: '5px 8px' }} onClick={() => setFilter('needs-ledger')}>
                      View Rows Needing Ledger
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      </div>

      {/* MODAL */}
      {modal && (
        <div className="modal-overlay">
          <div className="modal fade-in">
            <div className="modal-title">{modal.title}</div>
            <div className="modal-body" dangerouslySetInnerHTML={{ __html: modal.body }} />
            <div className="modal-actions">
              <button className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
              {modal.onConfirm && <button className="btn btn-success" onClick={modal.onConfirm}>Confirm & Post</button>}
            </div>
          </div>
        </div>
      )}

      {/* TOASTS */}
      <div id="toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast ${t.type}`}>
            <span>{t.type === 'success' ? '✓' : t.type === 'error' ? '✕' : t.type === 'info' ? 'ℹ' : '⚠'}</span>
            <span>{t.msg}</span>
          </div>
        ))}
      </div>
    </div>
  );
}